import { axiosInstance } from '../../services/api'

export const lifeEventApi = {
  // Get all event type templates
  getEventTypes: async () => {
    try {
      const response = await axiosInstance.get('/lifeevent/templates/')
      return response.data
    } catch (error) {
      if (error.response) {
        console.error("Error response:", error.response.data)
        throw new Error(error.response.data.message || JSON.stringify(error.response.data))
      } else if (error.request) {
        console.error("Error request:", error.request)
        throw new Error('No response received from server')
      } else {
        console.error("Error message:", error.message)
        throw new Error('An unexpected error occurred')
      }
    }
  },

  // Create a new life event
  createLifeEvent: async (eventData) => {
    try {
      // Get today's date in YYYY-MM-DD format
      const today = new Date().toISOString().split('T')[0]

      // Format the data according to API requirements
      const postBody = {
        template: eventData.template,
        title: eventData.title,
        category: eventData.category,
        status: eventData.status || 'draft',
        date: today,
        // Wrap form fields in event_data
        event_data: eventData.event_data,
        // Ensure story_responses is properly formatted
        story_responses: eventData.story_responses || {}
      }

      // Log the formatted request body

      const response = await axiosInstance.post('/lifeevent/events/', postBody, {
        headers: {
          'Content-Type': 'application/json'
        }
      })

      // Log the response

      return response.data
    } catch (error) {
      console.error('Error creating life event:', error)
      
      if (error.response) {
        console.error('Error response:', error.response.data)
        throw new Error(
          error.response.data.message || 
          error.response.data.detail || 
          JSON.stringify(error.response.data)
        )
      } else if (error.request) {
        console.error('Error request:', error.request)
        throw new Error('No response received from server')
      } else {
        console.error('Error message:', error.message)
        throw new Error('An unexpected error occurred')
      }
    }
  },

  // Get all life events for the current user
  getLifeEvents: async () => {
    try {
      const response = await axiosInstance.get('/lifeevent/events/')
      return response.data
    } catch (error) {
      if (error.response) {
        console.error("Error response:", error.response.data)
        throw new Error(error.response.data.message || JSON.stringify(error.response.data))
      } else if (error.request) {
        console.error("Error request:", error.request)
        throw new Error('No response received from server')
      } else {
        console.error("Error message:", error.message)
        throw new Error('An unexpected error occurred')
      }
    }
  },

  // Get a specific life event by ID
  getLifeEventById: async (eventId) => {
    try {
      const response = await axiosInstance.get(`/lifeevent/events/${eventId}/`)
      return response.data
    } catch (error) {
      if (error.response) {
        console.error("Error response:", error.response.data)
        throw new Error(error.response.data.message || JSON.stringify(error.response.data))
      } else if (error.request) {
        console.error("Error request:", error.request)
        throw new Error('No response received from server')
      } else {
        console.error("Error message:", error.message)
        throw new Error('An unexpected error occurred')
      }
    }
  },

  // Update an existing life event
  updateLifeEvent: async (eventId, eventData) => {
    try {
      const response = await axiosInstance.put(`/lifeevent/events/${eventId}/`, {
        category: eventData.category,
        title: eventData.title,
        event_type: eventData.eventType,
        date: eventData.date,
        location: eventData.location,
        description: eventData.description,
        story_details: eventData.storyDetails,
        key_people: eventData.keyPeople,
        media_files: eventData.mediaFiles,
        status: eventData.status
      })
      return response.data
    } catch (error) {
      if (error.response) {
        console.error("Error response:", error.response.data)
        throw new Error(error.response.data.message || JSON.stringify(error.response.data))
      } else if (error.request) {
        console.error("Error request:", error.request)
        throw new Error('No response received from server')
      } else {
        console.error("Error message:", error.message)
        throw new Error('An unexpected error occurred')
      }
    }
  },

  // Delete a life event
  deleteLifeEvent: async (eventId) => {
    try {
      const response = await axiosInstance.delete(`/lifeevent/events/${eventId}/`)
      return response.data
    } catch (error) {
      if (error.response) {
        console.error("Error response:", error.response.data)
        throw new Error(error.response.data.message || JSON.stringify(error.response.data))
      } else if (error.request) {
        console.error("Error request:", error.request)
        throw new Error('No response received from server')
      } else {
        console.error("Error message:", error.message)
        throw new Error('An unexpected error occurred')
      }
    }
  },

  // Upload media for a life event
  uploadEventMedia: async (eventId, mediaFiles) => {
    try {
      const formData = new FormData()
      mediaFiles.forEach((file, index) => {
        formData.append(`media_${index}`, file)
      })

      const response = await axiosInstance.post(`/lifeevent/events/${eventId}/media/`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      return response.data
    } catch (error) {
      if (error.response) {
        console.error("Error response:", error.response.data)
        throw new Error(error.response.data.message || JSON.stringify(error.response.data))
      } else if (error.request) {
        console.error("Error request:", error.request)
        throw new Error('No response received from server')
      } else {
        console.error("Error message:", error.message)
        throw new Error('An unexpected error occurred')
      }
    }
  }
} 